import { Fragment, useState, useEffect} from "react";
import Form from "./components/Form";
import Reunion from "./components/Reunion";


function App() {


  let reunionInicial = JSON.parse(localStorage.getItem('reunion'));

  if(!reunionInicial){
    reunionInicial=[];
  }


  const [reunion, guardarReunion] = useState(reunionInicial);

  useEffect(()=>{
    let reunionInicial = JSON.parse(localStorage.getItem('reunion'));
    if(reunionInicial){
      localStorage.setItem('reunion',JSON.stringify(reunion))
    }else{
      localStorage.setItem('reunion',JSON.stringify([]))
    }
  },[reunion])


  const crearReunion = reu =>{
    guardarReunion([
      ...reunion, 
      reu
    ]);
  }
  const eliminarReunion = id=>{
    reunion.filter(reu =>{
      const nuevaReunion = reunion.filter(reu =>reu.id !== id);
      guardarReunion(nuevaReunion);
    })
  }
 
  const mensaje = reunion.length === 0 ? 'No hay reuniones pendientes' : null;

  return (
    <Fragment>
      <div className="container">
        <div className="container-form">
          <div className="form">
          <h3>Administrador de reuniones</h3>
          <Form
            crearReunion = {crearReunion}
          />
          </div>
          <div className="cont-cita">
            <h2>{mensaje}</h2>
            {reunion.map(reu =>(
              <Reunion
               key = {reu.id}
               reu = {reu}
               eliminarReunion = {eliminarReunion}
              />
            ))}
          </div>
        </div>
      </div>
    </Fragment>
  );
}


export default App;
